import { useEffect } from 'react';

import { analytics } from '@sureapp/wl-toggle-common';

import CmsContent, { TRenderCmsContent } from '@@/auto/components/CmsContent';
import { useCmsContent } from '@@/common/hooks/useCmsContent';

import LayoutSelfService from '../LayoutSelfService';
import SpinnerView from '../SpinnerView';

import classes from './TermsView.module.css';

const termsAndConditionsCmsSlug = 'terms-and-conditions';

const renderCmsContent: TRenderCmsContent = ({ cmsContent, parseHTML }) => (
  <section data-testid="terms-content">
    {(cmsContent?.fields || [])?.map(({ id, text }) => (
      <section key={id}>{parseHTML(text || '')}</section>
    ))}
  </section>
);

type TTermsView = {
  cmsSlug: string;
};

function TermsView({ cmsSlug }: TTermsView) {
  const cmsContent = useCmsContent(termsAndConditionsCmsSlug);

  useEffect(() => {
    analytics.page();
  }, []);

  if (!cmsContent) {
    return <SpinnerView />;
  }

  return (
    <LayoutSelfService
      className={classes.root}
      header="Terms and Conditions"
      backgroundImgSrc={null}
    >
      <CmsContent
        data-testid="terms-content"
        entrySlug={cmsSlug}
        modelSlug={termsAndConditionsCmsSlug}
        renderContent={renderCmsContent}
      />
    </LayoutSelfService>
  );
}
export default TermsView;
